module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 106 36",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }